import { Component, OnInit, Input } from '@angular/core';
import { RoutingService } from '../../../../../services/routing-service/routing.service';
import { PrifactRoute } from '../../../../../models/prifact-route';
import { TeacherComment } from '../../../teachers-comments/models/teacher-comment';

@Component({
  selector: 'app-mobile-teachers-comments',
  templateUrl: './mobile-teachers-comments.component.html',
  styleUrls: ['./mobile-teachers-comments.component.scss']
})
export class MobileTeachersCommentsComponent implements OnInit {
  
  @Input() teachersComments: Array<TeacherComment>

  constructor(private routingService: RoutingService) { }

  ngOnInit() {
  }

  ngOnChanges() {
    if (this.teachersComments)
      this.teachersComments = this.teachersComments.filter(o => o.is_read_by_person == false);
  }

  commentClicked(id: number) {
    let route = new PrifactRoute();
    route.primary_command = ['pages', 'teachers-comments', id];
    route.append_current_url_to_history = true;
    this.routingService.navigate(route);
  }

  gotoTeachersComments() {
    let route = new PrifactRoute();
    route.primary_command = ['pages', 'teachers-comments'];
    route.append_current_url_to_history = true;
    this.routingService.navigate(route);
  }
}
